module.exports = __webpack_public_path__ + "img/29.3a371c12.png";